import { render, staticRenderFns } from "./lista-buscador-seleccion.vue?vue&type=template&id=271f1faa&scoped=true&"
import script from "./lista-buscador-seleccion.vue?vue&type=script&lang=ts&"
export * from "./lista-buscador-seleccion.vue?vue&type=script&lang=ts&"
import style0 from "./lista-buscador-seleccion.vue?vue&type=style&index=0&id=271f1faa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271f1faa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VIcon,VMenu,VRow,VSpacer})
